import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    allRights: '© {year} Ankr All rights reserved | {email}',
    tutorial: 'Tutorial start',
  },
};
